import { Tab, Tabs } from '@/components/ui';
import { NoAccess } from '@/components/common/noaccess';
import { useUserAccess } from '@/hooks/auth';
import { PcoSync } from './PcoSync';

export default function Platform() {
  const access = useUserAccess();

  if (!access?.admin) {
    return <NoAccess />;
  }

  return (
    <section className='mx-auto w-full max-w-7xl'>
      <div className='mb-3'>
        <h1 className='text-2xl font-semibold text-slate-950'>Platform</h1>
        <p className='mt-1 text-sm text-slate-500'>
          System-wide settings, integrations, and operational controls.
        </p>
      </div>
      <Tabs aria-label='Platform settings' variant='underlined'>
        <Tab key='pco-sync' title='PCO Sync'>
          <PcoSync />
        </Tab>
      </Tabs>
    </section>
  );
}
